import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { WebAccessControlCustomPagesDataProviderFactory } from '../factory/WebAccessControlCustomPagesDataProviderFactory';
import { WebAccessControlCustomPagesBaseDataProvider } from '../dataProvider/WebAccessControlCustomPagesBaseDataProvider';
import { WacPagesRecord } from '../types';

export class WebAccessControlCustomPagesRepository extends BaseWebComponentRepository {
  public dataProviderFactory: WebAccessControlCustomPagesDataProviderFactory;
  public dataProvider: WebAccessControlCustomPagesBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new WebAccessControlCustomPagesDataProviderFactory(),
    });
  }

  public async removeRecords(records: Array<WacPagesRecord>): Promise<{ success: boolean }> {
    return this.dataProvider.removeRecords(records);
  }
}
